module.exports = __webpack_public_path__ + "img/icon-email.b1f3b396.svg";